import {Role} from './role-model';

export class OpUser {
  constructor(
    public drmToken?: string,
    public email?: string,
    public externalId?: string,
    public id?: number,
    public name?: string,
    public online?: boolean,
    public opuiUrls?: string[],
    public password?: string,
    public role?: Role,
    public surname?: string,
    public title?: string,
    public token?: string,
    public username?: string,
  ) {}
}

// OpUserP {
//   drmToken (string, optional),
//   email (string, optional),
//   externalId (string, optional),
//   id (integer, optional),
//   name (string, optional),
//   online (boolean, optional),
//   opuiUrls (Array[string], optional),
//   password (string, optional),
//   role (Role, optional),
//   surname (string, optional),
//   title (string, optional),
//   token (string, optional),
//   username (string, optional)
//   }
